import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Context/AuthContext";
import { PatientProvider } from "./Context/PatientContext";
import ProtectedRoute from "./Routes/ProtectedRoute";
import Navbar from "./Components/Elements/Navbar";
import Dashboard from "./Components/Pages/Dashboard";
import PatientDetails from "./Components/Pages/PatientDetails";
import ClinicalParameters from "./Components/Pages/ClinicalParameters";
// import PracticeGuidelines from "./Components/Pages/PracticeGuidelines";
// import ChemotherapyProtocols from "./Components/Pages/ChemotherapyProtocols";
import Analytics from "./Components/Pages/Analytics";
import MessageFrame from "./Components/Pages/MessageFrame";
// import DoctorsFrame from "./Components/Pages/Doctors";
import Login from "./Components/Pages/Login";
import { paths } from "./Constants/paths";
import PatientMessage from "./Components/Pages/PatientMessage";
import Features from "./Components/Pages/Features";
import Pricing from "./Components/Pages/Pricing";
import ContactPage from "./Components/Pages/Contact";
import Navbar1 from "./Components/Elements/Navbar1/index.js";
// import DoctorMessage from "./Components/Pages/DoctorMessage";

const AuthenticatedLayout = ({ children }) => (
  <>
    {/* <Navbar /> */}
    <Navbar1 />
    {children}
  </>
);

const App = () => {
  return (
    <AuthProvider>
      <PatientProvider>
        <Routes>
          {/* Unauthenticated routes */}
          <Route path="/" element={<Login />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Protected routes */}
          {/* <Route
            path="/"
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Dashboard />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Dashboard />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path={`${paths.patient.details}/:patientId`}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <PatientDetails />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path={`${paths.patient.details}/:patientId/clinical-parameters`}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <ClinicalParameters />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          />
          {/* Disabled for phase 1 */}
          {/* <Route
            path={`${paths.guidelines}/practice-guidelines`}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <PracticeGuidelines />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          /> */}
          {/* <Route
            path={`${paths.guidelines}/chemotherapy-protocols`}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <ChemotherapyProtocols />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          /> */}
          <Route
            path={paths.analytics}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Analytics />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          />

          {/* Disabled for phase 1 */}
          <Route
            path={"/dashboard/messages"}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <MessageFrame />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path={"/dashboard/messages/:patientId"}
            element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <PatientMessage />
                </AuthenticatedLayout>
              </ProtectedRoute>
            }
          />

          {/* <Route
          path={"/dashboard/doctors/:doctorid"}
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <DoctorMessage />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        /> */}

          {/* <Route
          path={"/dashboard/doctors/"}
          element={
            <ProtectedRoute>
              <AuthenticatedLayout>
                <DoctorsFrame />
              </AuthenticatedLayout>
            </ProtectedRoute>
          }
        /> */}
        </Routes>
      </PatientProvider>
    </AuthProvider>
  );
};

export default App;
